import './_collection-hatbox-container.scss';

export default () => {};
